import React, { useContext, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Listingsidebar from '../../../Element/Listingsidebar';
import { userContext } from '../../../../contextProvider/Authentication';
import CareerInterest from './CareerInterest';
import Experience from './Experience';
import Education from './Education/Dashboard';
import Skills from './Skills';
import OnlinePresence from './OnlinePresence';
// import UploadCV from './UploadCV';
import Achievements from './Achievements';
import Languages from './Languages';
import axiosInstance from '../../../../services/AxiosInstance';
import userImg from '../../../../images/user.png';
import ConProfile from '../Profile/ConProfile';
var bnr = require('../../../../images/banner/bnr1.jpg');

function Jobmyresume(props) {
	const history = useHistory();

	const { joc, id } = props;
	const { user, authenticated } = useContext(userContext);
	const [pimg, setPImg] = useState(() => {
		if ((!id) && authenticated) return localStorage.getItem('pimg');
		else return null;
	});
	const [per, setData] = useState();
	const [can, setCan] = useState();

	useEffect(() => {
		axiosInstance(`user/profile_percentage/${joc ? id : user?.id}`, { method: "GET", }).then(res => setData(res?.data))
		axiosInstance(`candidate-profile/?fields=country,state,mobile&candidate=${joc ? id : user?.id}`, { method: "GET" })
			.then(res => {
				setCan(res?.data?.results?.[0]);
				if (id) setPImg(res?.data?.results?.[0]?.user?.pimg);
			})
		// eslint-disable-next-line
	}, []);

	return (
		<>
			<div className="page-content">
				<div className="overlay-black-dark profile-edit p-t50 p-b20" style={{ backgroundImage: "url(" + bnr + ")" }}>
					<div className="container">

						{
							can?.user?.first_name ?
								<div className="row">
									<div className="col-lg-8 col-md-7 candidate-info">
										<div className="candidate-detail">
											<div className="canditate-des text-center">
												<Link to={"#"}>
													<img alt="" src={pimg ? pimg : userImg} />
												</Link>
											</div>
											<div className="text-white browse-job text-left">
												<h4 className="m-b0">{can?.user?.first_name} {can?.user?.last_name}</h4>
												<ul className="clearfix">
													<li><i className="ti-location-pin"></i> {can?.state?.name}, {can?.country?.name}</li>
													<li><i className="ti-mobile"></i> +{can?.mobile}</li>
													<li><i className="ti-email"></i> {can?.user?.email}</li>
												</ul>
												<div className="progress-box m-t10">
													<div className="progress-info">Profile Strength ({(per < 30) ? 'Low' : (per < 70) ? 'Average' : 'Good'})
														<span>{per}%</span></div>
													<div className="progress">
														<div className="progress-bar bg-primary" style={{ width: `${per}%` }} role="progressbar" ></div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-5 candidate-info">
										<Link
											to="#"
											onClick={() => history.goBack()}
											className="text-white float-right"
										>
											Go Back
										</Link>
									</div>
								</div>
								:
								<div className="text-center text-white">
									<h4>Profile not updated</h4>
								</div>
						}

					</div>
				</div>

				<div className="content-block">
					<div className="section-full browse-job content-inner-2">
						<div className="container">
							<div className="row">
								<div className="col-xl-3 col-lg-4 col-md-4 col-sm-12 m-b30">
									<Listingsidebar stud_id={id} />
								</div>
								<div className="col-xl-9 col-lg-8 col-md-8 col-sm-12">
									{
										id &&
										<ConProfile stud_id={id} />
									}
									<CareerInterest stud_id={id} />
									<Experience stud_id={id} />
									<Education stud_id={id} />
									<Skills stud_id={id} />
									<Languages stud_id={id} />
									<OnlinePresence stud_id={id} />
									{/* <UploadCV /> */}
									<Achievements stud_id={id} />
									<div className="job-bx bg-white m-b30 text-center">
										<h3 className="mb-0">
											<i className="fa fa-eye" />
											<Link to={`/candidate-cv/${id ? id : user.id}`}> View Resume</Link>
										</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
export default Jobmyresume;